import Header from './Header/Header';
import { Box } from "@husqvarna/ui-core";
import "./Layout.scss";
import { ReactNode } from 'react';
interface LayoutProps {
  children: ReactNode;
}
const Layout = ({children} : LayoutProps) => (
  <Box
    className="tcsp-app"
    height="full"
    flexDirection="column"
  >
    <Header />
    <Box 
      component="main" 
      className="tcsp-main"
      container 
      flexGrow={1} 
      flexShrink={0}
    >
      {children}
      </Box>
  </Box>
);

export default Layout;